import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import SoftButton from "components/SoftButton";
import { hideFlowUsageDialog } from "redux/actions/flowDesigner/flowExecutionActionCreator";

const FlowUsageDialog = () => {
  const { flowUsageDialog } = useSelector(store => store?.designer?.flowExecution);
  const dispatch = useDispatch();
  const [fullWidth] = useState(true);
  const [maxWidth] = useState("sm");

  return (
    <Dialog fullWidth={fullWidth} maxWidth={maxWidth} open={flowUsageDialog?.open}>
      <DialogTitle>Execution Limit Reached</DialogTitle>
      <DialogContent>
        <DialogContentText>{flowUsageDialog?.message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <SoftButton color="error" onClick={() => dispatch(hideFlowUsageDialog())}>
          Close
        </SoftButton>
      </DialogActions>
    </Dialog>
  );
};

export default FlowUsageDialog;
